var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, useCallback, } from 'react';
import cn from 'classnames';
import styles from './styles.module.css.json';
/**
 * @example Full example
 *
 * ```js
 * <Canvas ctx={ctx}>
 *   <Form onSubmit={() => console.log('onSubmit')}>
 *     <FieldGroup>
 *       <TextField
 *         required
 *         name="name"
 *         id="name"
 *         label="Name"
 *         value="Mark Smith"
 *         placeholder="Enter full name"
 *         hint="Provide a full name"
 *         onChange={(newValue) => console.log(newValue)}
 *       />
 *       <TextField
 *         required
 *         name="email"
 *         id="email"
 *         label="Email"
 *         type="email"
 *         value=""
 *         placeholder="your@email.com"
 *         error="Please enter an email!"
 *         hint="Enter email address"
 *         onChange={(newValue) => console.log(newValue)}
 *       />
 *       <TextField
 *         required
 *         name="apiToken"
 *         id="apiToken"
 *         label="API Token"
 *         value="XXXYYY123"
 *         hint="Enter a valid API token"
 *         textInputProps={{ monospaced: true }}
 *         onChange={(newValue) => console.log(newValue)}
 *       />
 *       <SelectField
 *         name="option"
 *         id="option"
 *         label="Option"
 *         hint="Select one of the options"
 *         value={{ label: 'Option 1', value: 'option1' }}
 *         selectInputProps={{
 *           options: [
 *             { label: 'Option 1', value: 'option1' },
 *             { label: 'Option 2', value: 'option2' },
 *             { label: 'Option 3', value: 'option3' },
 *           ],
 *         }}
 *         onChange={(newValue) => console.log(newValue)}
 *       />
 *       <SelectField
 *         name="multipleOption"
 *         id="multipleOption"
 *         label="Multiple options"
 *         hint="Select one of the options"
 *         value={[
 *           { label: 'Option 1', value: 'option1' },
 *           { label: 'Option 2', value: 'option2' },
 *         ]}
 *         selectInputProps={{
 *           isMulti: true,
 *           options: [
 *             { label: 'Option 1', value: 'option1' },
 *             { label: 'Option 2', value: 'option2' },
 *             { label: 'Option 3', value: 'option3' },
 *           ],
 *         }}
 *         onChange={(newValue) => console.log(newValue)}
 *       />
 *       <SwitchField
 *         name="debugMode"
 *         id="debugMode"
 *         label="Debug mode active?"
 *         hint="Logs messages to console"
 *         value={true}
 *         onChange={(newValue) => console.log(newValue)}
 *       />
 *     </FieldGroup>
 *     <FieldGroup>
 *       <Button fullWidth buttonType="primary">
 *         Submit
 *       </Button>
 *     </FieldGroup>
 *   </Form>
 * </Canvas>;
 * ```
 */
export var Form = function (_a) {
    var children = _a.children, className = _a.className, onSubmit = _a.onSubmit, _b = _a.spacing, spacing = _b === void 0 ? 'default' : _b, otherProps = __rest(_a, ["children", "className", "onSubmit", "spacing"]);
    var classNames = cn(styles.Form, className);
    var formItemClassNames = cn(styles.Form__item, styles["Form__item--" + spacing]);
    var handleSubmit = useCallback(function (event) {
        event.preventDefault();
        if (onSubmit) {
            onSubmit(event);
        }
    }, [onSubmit]);
    return (React.createElement("form", __assign({ className: classNames, onSubmit: handleSubmit }, otherProps), Children.map(children, function (child) {
        if (child) {
            return React.createElement("div", { className: formItemClassNames }, child);
        }
        return null;
    })));
};
//# sourceMappingURL=index.js.map